"use client";

import { getSiteContent } from "@/content/site";
import { useLocale } from "@/lib/i18n/provider";

export default function SkipToContent() {
  const { locale } = useLocale();
  const copy = getSiteContent(locale);

  return (
    <a href="#main" className="skip-to-content">
      {copy.skipToContentLabel}
    </a>
  );
}
